import { Component, OnInit } from '@angular/core';
import { SharedService } from 'app/services/core/shared.service';
import { TrainingService } from 'app/services/training/training.service';
import { IApprovedCurriculum } from 'app/models/training/approved-curriculum';
import { AuthService } from 'app/auth/auth.service';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-manage-approved-curriculum',
    templateUrl: './approved-curriculum.component.html',
    styleUrls: ['./approved-curriculum.component.scss'],
    standalone: false
})
export class ApprovedCurriculumComponent implements OnInit {
  public approvedCurriculum: IApprovedCurriculum = { names: [] };
  public newApprovedCurriculum: string = '';
  public loading: boolean = false;
  public editingApprovedCurriculum: boolean = false;

  constructor(public sharedService: SharedService,
              public authService: AuthService,
              private trainingService: TrainingService,
              private toastr: ToastrService,) { }

  ngOnInit(): void {
    this.loading = true;
    this.trainingService.getApprovedCurriculum().subscribe({
      next: response => this.approvedCurriculum = response,
      error: e => console.log('error', e),
      complete: () => {
        this.loading = false;
      }
    });

  }

  removeCurriculum(index: number): void {
    this.sharedService.openConfirm('Are you sure you want to remove this curriculum?');
    this.sharedService.confirmed().subscribe(
      confirmed => {
        if(confirmed){
          this.approvedCurriculum.names.splice(index, 1);
          this.save();
       }
      }
    );
  }

  addCurriculum(): void {
    const name = this.newApprovedCurriculum.trim();
    if (name && !this.approvedCurriculum.names.includes(name)) {
      this.approvedCurriculum.names.push(name);
      this.newApprovedCurriculum = '';
      this.save();
    }
  }

  save(): void {
    this.trainingService.updateApprovedCurriculum(this.approvedCurriculum).subscribe({
      next: response => {
        if(response)
          this.toastr.success('Approved Curriculum updated');
      },
      error: e => console.log('error', e)
    });
  }

  toggleEdit(): void{
    this.editingApprovedCurriculum = !this.editingApprovedCurriculum;
    if (this.editingApprovedCurriculum) {
      this.newApprovedCurriculum = '';
    }
  }
}
